import {
  FiBriefcase,
  FiUsers,
  FiClock,
  FiShield,
  FiCamera,
  FiDatabase,
  FiMapPin,
  FiSettings,
  FiServer,
  FiDownload
} from 'react-icons/fi';

function Configuracoes() {
  const cards = [
    { titulo: 'Empresas', icone: <FiBriefcase /> },
    { titulo: 'Usuários', icone: <FiUsers /> },
    { titulo: 'Jornada de Trabalho', icone: <FiClock /> },
    { titulo: 'Tolerâncias', icone: <FiSettings /> },
    { titulo: 'Biometria Facial', icone: <FiCamera /> },
    { titulo: 'Segurança', icone: <FiShield /> },
    { titulo: 'Localização GPS', icone: <FiMapPin /> },
    { titulo: 'Banco de Dados', icone: <FiDatabase /> },
    { titulo: 'Servidor', icone: <FiServer /> },
    { titulo: 'Backup', icone: <FiDownload /> }
  ];

  return (
    <div className="content">
      <div className="page-header">
        <h2>Configurações</h2>
      </div>

      <div className="config-grid">
        {cards.map((card) => (
          <div className="config-card" key={card.titulo}>
            <div className="config-icon">
              {card.icone}
            </div>

            <span>{card.titulo}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Configuracoes;
